import { createBrowserRouter, Navigate, Outlet } from "react-router-dom";
import HowToUseApp from "../pages/help/HowToUseApp";
import AddTransactions from "../pages/help/AddTransactions";
import SetBudget from "../pages/help/SetBudget";
import UploadBankStatement from "../pages/help/UploadBankStatement";
import ConnectBankAccount from "../pages/help/ConnectBankAccount";
import AddBills from "../pages/help/AddBills";
import ScanReceipt from "../pages/help/ScanReceipt";
import LanguageSync from "../components/LanguageSync";

const RootLayout = () => (
  <LanguageSync>
    <Outlet />
  </LanguageSync>
);

const router = createBrowserRouter(
  [
    {
      element: <RootLayout />,
      children: [
        { path: "/how-to-use", element: <HowToUseApp /> },
        { path: "/how-to-add-transactions", element: <AddTransactions /> },
        { path: "/how-to-set-budget", element: <SetBudget /> },
        { path: "/how-to-connect-bank", element: <ConnectBankAccount /> },
        { path: "/how-to-upload-bank-statement", element: <UploadBankStatement /> },
        { path: "/how-to-add-bills", element: <AddBills /> },
        { path: "/how-to-scan-receipt", element: <ScanReceipt /> },
        { path: "/", element: <Navigate to="/how-to-use" replace /> },
        { path: "*", element: <Navigate to="/how-to-use" replace /> },
      ],
    },
  ],
  {
    basename: process.env.REACT_APP_HOME_PAGE,
  }
);

export default router;